import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';

@Component({
    selector: 'tt-calculation-season-year',
    templateUrl: './calculation-season-year.component.html',
    styleUrls: ['./calculation-season-year.component.css'],
    standalone: false
})
export class CalculationSeasonYearComponent implements OnInit {
    public grid?: GridOptions;

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_calculationseasonyear_grid')
                .setLoadDataFunction({
                    method: 2639,
                    parameters: {}
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}
